// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import BurgerIcon from '../../Util/BurgerIcon/BurgerIcon';
import Navigation from '../Navigation/Navigation';
import Login from '../../User/Login/Login';
import { observer, inject } from 'mobx-react';
import { CSSTransitionGroup  } from 'react-transition-group';
import './Header.scss';
import { Link } from 'react-router-dom';

@inject('modalStore', 'userStore', 'componentStore')
@observer class Header extends Component<any, any> {

	constructor(props: any) {
		super(props);

		this.toogleNavigation = this.toogleNavigation.bind(this);
		this.openLogin = this.openLogin.bind(this);
	}

	toogleNavigation(): void {
		this.props.componentStore.nav = !this.props.componentStore.nav;
	}

	openLogin(): void {
		this.props.modalStore.createModal('Login', <Login />);
	}

	render() {
		return (
			<header>
				<div className="open-nav-icon">
					<BurgerIcon handler={this.toogleNavigation} nav={this.props.componentStore.nav} />
				</div>
				<CSSTransitionGroup  
					transitionName="animate-nav"
					transitionEnterTimeout={400}
					transitionLeaveTimeout={400}>
					{this.props.componentStore.nav ?
						<Navigation /> 
					: null}
				</CSSTransitionGroup>
				<h1><Link to="/">change my mind.</Link></h1>
				<div className="user-menu">
					{this.props.userStore.user ? 
						<Link to="/profile" className="icon-user-circle profile-icon"></Link>
					:
						<a className="login" href="#" onClick={(e) => { e.preventDefault(); this.openLogin(); }}>Login</a>
					}
					
				</div>
			</header>
		)
	}
}

export default Header;